/**
 * Redirects a path with a trailing slash to the path without the slash and keeps the query and the hash.
 * This middleware must run before all other route middleware, because they expect paths without a trailing slash.
 * Do not set `replace: true`: it replaces the history entry of the previous page.
 */
export default defineNuxtRouteMiddleware((to) => {
    const normalizedPath = normalizeInternalPath(to.path);

    if (normalizedPath === to.path) {
        return;
    }

    log.debug(`[00.trailingSlashRedirect.global.ts] Redirecting ${to.path} to ${normalizedPath}.`);
    // A redirect from a different middleware can be temporary. Do not make it permanent.
    return navigateTo(
        { path: normalizedPath, query: to.query, hash: to.hash },
        { redirectCode: to.redirectedFrom ? 302 : 301 }
    );
});
